<template>
  <div>
    <Movementmenu />
    <v-container fluid class="grey lighten-4 pa-6">
      <v-row dense class="mb-4">
        <v-col cols="12" sm="6" md="2">
          <v-card
            class="rounded-lg shadow-sm cursor-pointer"
            hover
            @click="conditions_transferQueryAll"
          >
            <v-list-item two-line>
              <v-list-item-content>
                <div class="overline mb-1 grey--text">ทั้งหมด</div>
                <v-list-item-title class="headline font-weight-bold">{{
                  sumconditions_transfer.sum
                }}</v-list-item-title>
              </v-list-item-content>
              <v-avatar size="40" color="blue lighten-5"
                ><v-icon color="blue">mdi-clipboard-list</v-icon></v-avatar
              >
            </v-list-item>
          </v-card>
        </v-col>

        <v-col cols="12" sm="6" md="2">
          <v-card
            class="rounded-lg shadow-sm cursor-pointer"
            hover
            @click="conditions_transferStatusrc"
          >
            <v-list-item two-line>
              <v-list-item-content>
                <div class="overline mb-1 success--text">ตรวจสอบแล้ว</div>
                <v-list-item-title
                  class="headline font-weight-bold success--text"
                  >{{ sumconditions_transfer.sumreceive }}</v-list-item-title
                >
              </v-list-item-content>
              <v-avatar size="40" color="green lighten-5"
                ><v-icon color="green">mdi-check-circle</v-icon></v-avatar
              >
            </v-list-item>
          </v-card>
        </v-col>

        <v-col cols="12" sm="6" md="2">
          <v-card
            class="rounded-lg shadow-sm cursor-pointer"
            hover
            @click="conditions_transferStatusrcb"
          >
            <v-list-item two-line>
              <v-list-item-content>
                <div class="overline mb-1 warning--text">ไม่สมบูรณ์</div>
                <v-list-item-title
                  class="headline font-weight-bold warning--text"
                  >{{
                    sumconditions_transfer.sumreceive_but
                  }}</v-list-item-title
                >
              </v-list-item-content>
              <v-avatar size="40" color="amber lighten-5"
                ><v-icon color="amber darken-2">mdi-alert</v-icon></v-avatar
              >
            </v-list-item>
          </v-card>
        </v-col>

        <v-col cols="12" sm="6" md="2">
          <v-card
            class="rounded-lg shadow-sm cursor-pointer"
            hover
            @click="conditions_transferStatusrl"
          >
            <v-list-item two-line>
              <v-list-item-content>
                <div class="overline mb-1 error--text">ไม่รับย้าย/ยกเลิก</div>
                <v-list-item-title
                  class="headline font-weight-bold error--text"
                >
                  {{
                    parseInt(sumconditions_transfer.sumrelocated || 0) +
                      parseInt(sumconditions_transfer.sumcc || 0)
                  }}
                </v-list-item-title>
              </v-list-item-content>
              <v-avatar size="40" color="red lighten-5"
                ><v-icon color="red">mdi-close-circle</v-icon></v-avatar
              >
            </v-list-item>
          </v-card>
        </v-col>

        <v-col cols="12" sm="6" md="2">
          <v-card
            class="rounded-lg shadow-sm cursor-pointer"
            hover
            @click="search_not_submit"
          >
            <v-list-item two-line>
              <v-list-item-content>
                <div class="overline mb-1 deep-orange--text">
                  ยังไม่ส่งข้อมูล
                </div>
                <v-list-item-title
                  class="headline font-weight-bold deep-orange--text"
                  >Filter</v-list-item-title
                >
              </v-list-item-content>
              <v-avatar size="40" color="deep-orange lighten-5"
                ><v-icon color="deep-orange"
                  >mdi-account-clock</v-icon
                ></v-avatar
              >
            </v-list-item>
          </v-card>
        </v-col>

        <v-col cols="12" sm="6" md="2">
          <v-card
            class="rounded-lg shadow-sm cursor-pointer"
            hover
            @click="search_confirm"
          >
            <v-list-item two-line>
              <v-list-item-content>
                <div class="overline mb-1 info--text">รอตรวจสอบ</div>
                <v-list-item-title class="headline font-weight-bold info--text"
                  >Filter</v-list-item-title
                >
              </v-list-item-content>
              <v-avatar size="40" color="cyan lighten-5"
                ><v-icon color="cyan">mdi-eye</v-icon></v-avatar
              >
            </v-list-item>
          </v-card>
        </v-col>
      </v-row>

      <base-material-card
        icon="mdi-format-list-checks"
        title="ข้อมูลการย้าย สายการสอนและสายสนับสนุน"
        color="primary"
        class="px-5 py-3"
      >
        <v-card flat class="grey lighten-5 rounded-lg mb-4 pa-4">
          <v-row align="center">
            <v-col cols="12" md="8" class="d-flex flex-wrap" style="gap: 10px;">
              <v-btn
                small
                rounded
                dark
                color="indigo"
                :href="reportLinks.conditionAll"
                target="_blank"
              >
                <v-icon left>mdi-printer</v-icon> รายงานเงื่อนไข (รอบปัจจุบัน)
              </v-btn>
              <v-btn
                small
                rounded
                dark
                color="teal"
                href="#/admin/print_jor18_teacherMove/"
                target="_blank"
              >
                <v-icon left>mdi-printer-settings</v-icon> เงื่อนไขทั้งหมด
              </v-btn>
              <v-btn
                small
                rounded
                outlined
                color="success"
                @click="exportToExcel"
              >
                <v-icon left>mdi-file-excel</v-icon> ส่งออก Excel
              </v-btn>

              <v-menu offset-y>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    small
                    rounded
                    outlined
                    color="deep-orange"
                    v-bind="attrs"
                    v-on="on"
                  >
                    <v-icon left>mdi-filter-variant</v-icon> ตัวเลือกกรองพิเศษ
                  </v-btn>
                </template>
                <v-list dense>
                  <v-list-item @click="search_not_submit_but">
                    <v-list-item-icon
                      ><v-icon color="red"
                        >mdi-account-alert</v-icon
                      ></v-list-item-icon
                    >
                    <v-list-item-title
                      >มีตำแหน่งว่างแต่ไม่ดำเนินการ</v-list-item-title
                    >
                  </v-list-item>
                  <v-list-item @click="search_documentFile">
                    <v-list-item-icon
                      ><v-icon color="red"
                        >mdi-file-hidden</v-icon
                      ></v-list-item-icon
                    >
                    <v-list-item-title
                      >สถานศึกษาไม่ได้แนบไฟล์</v-list-item-title
                    >
                  </v-list-item>
                </v-list>
              </v-menu>
            </v-col>

            <v-col cols="12" md="4">
              <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                label="ค้นหา (ชื่อวิทยาลัย, รหัส, สถานะ)"
                outlined
                dense
                rounded
                hide-details
                class="bg-white"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-card>

        <v-data-table
          :headers="headers"
          :items="conditions_transfers"
          :search="search"
          :loading="loading"
          class="elevation-0 custom-table"
          :item-class="row_classes"
        >
          <template v-slot:item.college_name="{ item }">
            <div class="font-weight-bold">{{ item.college_name }}</div>
            <div class="caption grey--text">{{ item.college_code }}</div>
          </template>

          <template v-slot:item.documentsLinkfile="{ item }">
            <div
              v-if="item.documentsLinkfile"
              class="d-flex align-center justify-center"
            >
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    icon
                    color="primary"
                    @click="viewdocumentsLinkfile(item.documentsLinkfile)"
                    v-bind="attrs"
                    v-on="on"
                  >
                    <v-icon>mdi-file-eye</v-icon>
                  </v-btn>
                </template>
                <span>ดูไฟล์</span>
              </v-tooltip>

              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    icon
                    color="error"
                    small
                    @click="cancel_condition(item.id_ref)"
                    v-bind="attrs"
                    v-on="on"
                  >
                    <v-icon>mdi-delete-outline</v-icon>
                  </v-btn>
                </template>
                <span>ลบไฟล์</span>
              </v-tooltip>
            </div>
            <div v-else class="text-center">
              <v-btn
                small
                outlined
                color="info"
                rounded
                @click="AddConditionFile(item.id_ref)"
              >
                <v-icon left small>mdi-upload</v-icon> แนบไฟล์
              </v-btn>
            </div>
          </template>

          <template v-slot:item.status_confirm="{ item }">
            <div
              class="text-center"
              style="cursor: pointer"
              @click="
                item.status_confirm !== 'cc'
                  ? receive_status(item.id_ref)
                  : null
              "
            >
              <v-chip
                v-if="item.status_confirm === 'receive'"
                color="success"
                small
                dark
                label
              >
                <v-icon left x-small>mdi-check</v-icon> ถูกต้องครบถ้วน
              </v-chip>
              <v-chip
                v-else-if="item.status_confirm === 'receive_but'"
                color="warning"
                small
                dark
                label
              >
                <v-icon left x-small>mdi-alert</v-icon> ไม่สมบูรณ์
              </v-chip>
              <v-chip
                v-else-if="item.status_confirm === 'relocated'"
                color="grey darken-2"
                small
                dark
                label
              >
                <v-icon left x-small>mdi-cancel</v-icon> ไม่รับย้าย
              </v-chip>
              <v-chip
                v-else-if="item.status_confirm === 'dt_receive'"
                color="error"
                small
                dark
                label
              >
                <v-icon left x-small>mdi-close</v-icon> ไม่ได้รับ
              </v-chip>
              <v-chip
                v-else-if="item.status_confirm === 'cc'"
                color="yellow darken-3"
                small
                dark
                label
              >
                ยกเลิก
              </v-chip>
              <v-chip v-else color="info" small outlined label>
                รอตรวจสอบ
              </v-chip>
            </div>
          </template>

          <template v-slot:item.cancel_row="{ item }">
            <div class="text-center">
              <span v-if="item.count_idref === '0'" class="caption error--text"
                >ไม่สำเร็จ</span
              >
              <span
                v-else-if="item.action_sub === 'not_submit'"
                class="caption deep-orange--text"
                >ยังไม่ส่ง</span
              >
              <span
                v-else-if="item.action_sub === 'not_submit_but'"
                class="caption warning--text"
                >มีตำแหน่ง/ไม่ส่ง</span
              >
              <v-btn
                v-else
                icon
                color="grey"
                @click="delete_condition(item.id_ref)"
              >
                <v-icon>mdi-delete</v-icon>
              </v-btn>
            </div>
          </template>

          <template v-slot:item.select_item="{ item }">
            <v-checkbox
              v-model="selectedItems"
              :value="item.college_code"
              hide-details
              class="mt-0 pt-0"
            ></v-checkbox>
          </template>
        </v-data-table>
      </base-material-card>

      <v-dialog v-model="receive_dialog" persistent max-width="600px">
        <v-card class="rounded-lg">
          <v-toolbar color="primary" dark flat>
            <v-toolbar-title>ตรวจสอบเอกสารการรับย้าย</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn icon @click="receive_dialog = false"
              ><v-icon>mdi-close</v-icon></v-btn
            >
          </v-toolbar>
          <v-card-text class="pt-4">
            <div class="subtitle-1 font-weight-bold mb-2">
              {{ conditions_transfers_select.college_name }}
            </div>
            <div class="caption grey--text mb-4">
              Ref: {{ conditions_transfers_select.id_ref }}
            </div>

            <v-alert colored-border border="left" color="primary" elevation="1">
              <v-radio-group
                v-model="conditions_transfers_select.status_confirm"
                hide-details
              >
                <v-radio
                  value="receive"
                  label="ได้รับแล้ว (ถูกต้องสมบูรณ์)"
                  color="success"
                ></v-radio>
                <v-radio
                  value="receive_but"
                  label="ได้รับแล้ว (แต่ไม่สมบูรณ์)"
                  color="warning"
                ></v-radio>
                <v-radio
                  value="dt_receive"
                  label="ไม่ได้รับเอกสาร"
                  color="error"
                ></v-radio>
                <v-radio
                  value="relocated"
                  label="ไม่ประสงค์รับย้าย"
                  color="grey darken-3"
                ></v-radio>
              </v-radio-group>
            </v-alert>

            <v-text-field
              v-model="conditions_transfers_select.comment_s"
              outlined
              label="หมายเหตุ / เอกสารที่ขาด"
              prepend-inner-icon="mdi-comment-text-outline"
            ></v-text-field>
          </v-card-text>
          <v-card-actions class="justify-end pa-4">
            <v-btn text @click="receive_dialog = false">ยกเลิก</v-btn>
            <v-btn color="primary" depressed @click="receive_Submit"
              >บันทึกผล</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="receive_cancel_dialog" persistent max-width="600px">
        <v-card class="rounded-lg">
          <v-toolbar color="warning darken-1" dark flat>
            <v-toolbar-title>แก้ไขสถานะการตรวจสอบ</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn icon @click="receive_cancel_dialog = false"
              ><v-icon>mdi-close</v-icon></v-btn
            >
          </v-toolbar>
          <v-card-text class="pt-4">
            <div class="subtitle-1 font-weight-bold mb-2">
              {{ conditions_transfers_select.college_name }}
            </div>

            <v-alert colored-border border="left" color="warning" elevation="1">
              <v-radio-group
                v-model="conditions_transfers_select.status_confirm"
              >
                <v-radio
                  value="receive"
                  label="ได้รับแล้ว (ถูกต้องสมบูรณ์)"
                ></v-radio>
                <v-radio
                  value="receive_but"
                  label="ได้รับแล้ว (แต่ไม่สมบูรณ์)"
                ></v-radio>
                <v-radio value="dt_receive" label="ไม่ได้รับเอกสาร"></v-radio>
                <v-radio value="relocated" label="ไม่ประสงค์รับย้าย"></v-radio>
              </v-radio-group>
            </v-alert>

            <v-text-field
              v-model="conditions_transfers_select.comment_s"
              outlined
              label="หมายเหตุแก้ไข"
            ></v-text-field>
          </v-card-text>
          <v-card-actions class="justify-end pa-4">
            <v-btn text @click="receive_cancel_dialog = false">ยกเลิก</v-btn>
            <v-btn color="warning" depressed @click="receive_cancel_Submit"
              >บันทึกการแก้ไข</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog
        v-model="Filecondition_transfer_dialog"
        persistent
        max-width="500px"
      >
        <v-card class="rounded-lg">
          <v-toolbar color="info" dark flat>
            <v-toolbar-title>แนบไฟล์เอกสาร (Admin Mode)</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn icon @click="Filecondition_transfer_dialog = false"
              ><v-icon>mdi-close</v-icon></v-btn
            >
          </v-toolbar>
          <v-card-text class="pt-6">
            <div class="mb-4">{{ conditions_transfers_File.college_name }}</div>
            <v-file-input
              v-model="documentsLinkfile"
              accept=".pdf"
              label="เลือกไฟล์ PDF"
              outlined
              dense
              show-size
              prepend-icon="mdi-file-pdf-box"
            ></v-file-input>
          </v-card-text>
          <v-card-actions class="justify-end pa-4">
            <v-btn text @click="Filecondition_transfer_dialog = false"
              >ยกเลิก</v-btn
            >
            <v-btn color="success" depressed @click="FileconditionSubmit"
              >อัปโหลด</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog
        v-model="deletecondition_transfer_dialog"
        persistent
        max-width="450px"
      >
        <v-card class="rounded-lg">
          <v-card-title class="headline error--text">
            <v-icon color="error" class="mr-2">mdi-delete-alert</v-icon>
            ยืนยันลบไฟล์แนบ
          </v-card-title>
          <v-card-text>
            <div class="body-1 mb-2">
              {{ conditions_transfers_select.college_name }}
            </div>
            <v-form ref="deleteconditions_transer_form" lazy-validation>
              <v-text-field
                label="Admin Password"
                v-model="conditions_transfers_select.password_b"
                :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                :type="show1 ? 'text' : 'password'"
                @click:append="show1 = !show1"
                outlined
                dense
                required
                :rules="[v => v == '0612698358' || 'รหัสผ่านผิด']"
              ></v-text-field>
            </v-form>
          </v-card-text>
          <v-card-actions class="justify-end">
            <v-btn text @click="deletecondition_transfer_dialog = false"
              >ยกเลิก</v-btn
            >
            <v-btn
              color="error"
              depressed
              @click="delete_conditions_transfer_Submit"
              >ยืนยันลบ</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="deleteconditiondialog" persistent max-width="450px">
        <v-card class="rounded-lg">
          <v-card-title class="headline error--text">
            <v-icon color="error" class="mr-2">mdi-delete-forever</v-icon>
            ลบรายการทั้งวิทยาลัย
          </v-card-title>
          <v-card-text>
            <div class="body-1 mb-2">
              ข้อมูลของ:
              {{
                conditions_transfers_select.college_name
              }}
              จะถูกลบทั้งหมดเพื่อให้สถานศึกษาดำเนินการใหม่
            </div>
            <v-form ref="deleteconditionsform" lazy-validation>
              <v-text-field
                label="Admin Password"
                v-model="conditions_transfers_select.password_b"
                :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                :type="show1 ? 'text' : 'password'"
                @click:append="show1 = !show1"
                outlined
                dense
                required
                :rules="[v => v == '0612698358' || 'รหัสผ่านผิด']"
              ></v-text-field>
            </v-form>
          </v-card-text>
          <v-card-actions class="justify-end">
            <v-btn text @click="deleteconditiondialog = false">ยกเลิก</v-btn>
            <v-btn color="error" depressed @click="deleteconditionSubmit"
              >ยืนยันลบ</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog
        v-model="pdfdocumentsLinkfileDialog"
        max-width="90%"
        fullscreen
        hide-overlay
        transition="dialog-bottom-transition"
      >
        <v-card>
          <v-toolbar dark color="primary">
            <v-btn icon dark @click="pdfdocumentsLinkfileDialog = false"
              ><v-icon>mdi-close</v-icon></v-btn
            >
            <v-toolbar-title>เอกสารแนบ</v-toolbar-title>
          </v-toolbar>
          <div style="height: 100vh;">
            <embed
              :src="'https://hrvec.ovec.go.th/HRvecfiles/' + pdf_files"
              width="100%"
              height="100%"
            />
          </div>
        </v-card>
      </v-dialog>

      <v-snackbar
        v-model="snackbar.show"
        :color="snackbar.color"
        top
        right
        rounded="pill"
      >
        <v-icon left>{{ snackbar.icon }}</v-icon> {{ snackbar.text }}
        <template v-slot:action="{ attrs }">
          <v-btn text v-bind="attrs" @click="snackbar.show = false">ปิด</v-btn>
        </template>
      </v-snackbar>
    </v-container>
  </div>
</template>

<script>
import Movementmenu from "../../components/admin/movementmenu.vue";
import * as XLSX from "xlsx"; // ต้องรัน npm install xlsx

export default {
  components: { Movementmenu },
  data() {
    return {
      loading: false,
      ApiKey: "HRvec2021",
      search: "",
      show1: false,
      selectedItems: [],

      // Dialog State
      receive_dialog: false,
      receive_cancel_dialog: false,
      deletecondition_transfer_dialog: false,
      deleteconditiondialog: false,
      Filecondition_transfer_dialog: false,
      pdfdocumentsLinkfileDialog: false,

      // Data
      conditions_transfers: [],
      conditions_transfers_select: {},
      conditions_transfers_File: {},
      updateFileconditions: {},
      sumconditions_transfer: {
        sum: 0,
        sumcc: 0,
        sumreceive: 0,
        sumreceive_but: 0,
        sumrelocated: 0,
        sumdocpvcfile: 0
      },
      period_colleges: {},
      documentsLinkfile: null,
      pdf_files: null,

      snackbar: { show: false, color: "", icon: "", text: "" },
      headers: [
        { text: "เลือก", value: "select_item", sortable: false },
        { text: "รหัส", align: "center", value: "college_code" },
        { text: "สถานศึกษา", align: "left", value: "college_name" },
        { text: "วันที่ส่ง", align: "center", value: "date_time" },
        { text: "อัตราว่าง", align: "center", value: "man_power_college" },
        { text: "ไฟล์แนบ", align: "center", value: "documentsLinkfile" },
        { text: "สถานะตรวจสอบ", align: "center", value: "status_confirm" },
        {
          text: "ดำเนินการ",
          align: "center",
          value: "cancel_row",
          sortable: false
        }
      ]
    };
  },

  computed: {
    reportLinks() {
      const {
        period_college_times,
        period_college_year
      } = this.period_colleges;
      return {
        conditionAll: `#/admin/print_report_condition_all/${period_college_times}/${period_college_year}`
      };
    }
  },

  async mounted() {
    await this.period_collegeQuery();
    await this.conditions_transferQueryAll();
  },

  methods: {
    // --- Data Fetching & Core Logic ---
    async period_collegeQuery() {
      let res = await this.$http.post("period_college.php", {
        ApiKey: this.ApiKey,
        period_college_id: "401"
      });
      this.period_colleges = res.data;
    },

    async conditions_transferQueryAll() {
      this.loading = true;
      try {
        let res = await this.$http.post("conditions_transfer_admin.php", {
          ApiKey: this.ApiKey,
          time_s: this.period_colleges.period_college_times,
          year_s: this.period_colleges.period_college_year
        });
        this.conditions_transfers = res.data;
        this.calculateStats();
      } finally {
        this.loading = false;
      }
    },

    calculateStats() {
      let stats = {
        sum: 0,
        sumcc: 0,
        sumreceive: 0,
        sumreceive_but: 0,
        sumrelocated: 0,
        sumdocpvcfile: 0
      };
      this.conditions_transfers.forEach(v => {
        stats.sum++;
        if (v.documentsLinkfile) stats.sumdocpvcfile++;
        if (v.status_confirm === "cc") stats.sumcc++;
        if (v.status_confirm === "receive") stats.sumreceive++;
        if (v.status_confirm === "receive_but") stats.sumreceive_but++;
        if (v.status_confirm === "relocated") stats.sumrelocated++;
      });
      this.sumconditions_transfer = stats;
    },

    // --- Filters (API Based) ---
    async fetchWithFilter(params) {
      this.loading = true;
      try {
        let res = await this.$http.post("conditions_transfer_admin.php", {
          ApiKey: this.ApiKey,
          time_s: this.period_colleges.period_college_times,
          year_s: this.period_colleges.period_college_year,
          ...params
        });
        this.conditions_transfers = res.data;
      } finally {
        this.loading = false;
      }
    },

    conditions_transferStatusrc() {
      this.fetchWithFilter({ status_confirm: "receive" });
    },
    conditions_transferStatusrcb() {
      this.fetchWithFilter({ status_confirm: "receive_but" });
    },
    conditions_transferStatusrl() {
      this.fetchWithFilter({ status_confirm: "relocated" });
    }, // Note: original code might separate 'relocated' and 'cc', check logic if needed combined
    search_not_submit() {
      this.fetchWithFilter({ check_not_submit: "ok" });
    },
    search_not_submit_but() {
      this.fetchWithFilter({ check_not_submit_but: "ok" });
    },
    search_documentFile() {
      this.fetchWithFilter({ check_documentFile: "ok" });
    },

    // Local Filter Logic for "Waiting for Verify"
    search_confirm() {
      this.conditions_transfers = this.conditions_transfers.filter(v => {
        const hasDoc = String(v.documentsLinkfile).length > 5;
        const notVerified = !["relocated", "receive_but", "receive"].includes(
          v.status_confirm
        );
        return hasDoc && notVerified;
      });
    },

    // --- Excel Export ---
    exportToExcel() {
      const data = this.conditions_transfers.map(item => ({
        รหัสสถานศึกษา: item.college_code,
        ชื่อสถานศึกษา: item.college_name,
        วันที่ส่ง: item.date_time || "ยังไม่ส่ง",
        อัตราว่าง: item.man_power_college,
        สถานะ: this.getStatusText(item.status_confirm),
        หมายเหตุ: item.comment_s || ""
      }));

      const ws = XLSX.utils.json_to_sheet(data);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "Transfer_Conditions");
      XLSX.writeFile(wb, `Condition_Report_${Date.now()}.xlsx`);
    },

    getStatusText(status) {
      const map = {
        receive: "ถูกต้อง",
        receive_but: "ไม่สมบูรณ์",
        relocated: "ไม่รับย้าย",
        dt_receive: "ไม่ได้รับเอกสาร",
        cc: "ยกเลิก"
      };
      return map[status] || "รอตรวจสอบ";
    },

    // --- Actions (Receive/Delete/File) ---
    async receive_status(id_ref) {
      let res = await this.$http.post("conditions_transfer.php", {
        ApiKey: this.ApiKey,
        id_ref
      });
      this.conditions_transfers_select = res.data;
      this.receive_dialog = true;
    },

    async receive_Submit() {      
        await this.updateStatus(
          "conditions_transfer.update.php",
          this.conditions_transfers_select,
          "บันทึกสถานะเรียบร้อย"
        );
        this.receive_dialog = false;
      
    },

    async receive_cancel_Submit() {
      await this.updateStatus(
        "conditions_transfer.update.php",
        this.conditions_transfers_select,
        "แก้ไขสถานะเรียบร้อย"
      );
      this.receive_cancel_dialog = false;
    },

    async updateStatus(endpoint, payload, successMsg) {
      payload.ApiKey = this.ApiKey;
      let res = await this.$http.post(endpoint, payload);
      if (res.data.status) {
        this.showSnackbar(successMsg, "success");
        await this.conditions_transferQueryAll();
      } else {
        this.showSnackbar("เกิดข้อผิดพลาด", "error");
      }
    },

    async cancel_condition(id_ref) {
      let res = await this.$http.post("conditions_transfer.php", {
        ApiKey: this.ApiKey,
        id_ref
      });
      this.conditions_transfers_select = res.data;
      this.conditions_transfers_select.password_b = ""; // Clear password
      this.deletecondition_transfer_dialog = true;
    },

    async delete_conditions_transfer_Submit() {
      if (this.$refs.deleteconditions_transer_form.validate()) {
        this.conditions_transfers_select.ApiKey = this.ApiKey;
        // 1. Update Record
        let res = await this.$http.post(
          "conditions_transfer.admin.update.php",
          this.conditions_transfers_select
        );
        // 2. Delete File
        await this.$http.post("deletefile.php", {
          ApiKey: this.ApiKey,
          filename:
            "../HRvecfiles/" +
            this.conditions_transfers_select.documentsLinkfile
        });

        if (res.data.status) {
          this.showSnackbar("ลบไฟล์เรียบร้อย", "success");
          await this.conditions_transferQueryAll();
        }
        this.deletecondition_transfer_dialog = false;
      }
    },

    async delete_condition(id_ref) {
      let res = await this.$http.post("conditions_transfer.php", {
        ApiKey: this.ApiKey,
        id_ref
      });
      this.conditions_transfers_select = res.data;
      this.conditions_transfers_select.password_b = "";
      this.deleteconditiondialog = true;
    },

    async deleteconditionSubmit() {
      if (this.$refs.deleteconditionsform.validate()) {
        this.conditions_transfers_select.ApiKey = this.ApiKey;
        let res = await this.$http.post(
          "conditions_transfer.delete.php",
          this.conditions_transfers_select
        );
        // Try deleting file too just in case
        if (this.conditions_transfers_select.documentsLinkfile) {
          await this.$http.post("deletefile.php", {
            ApiKey: this.ApiKey,
            filename:
              "../HRvecfiles/" +
              this.conditions_transfers_select.documentsLinkfile
          });
        }

        if (res.data.status) {
          this.showSnackbar("ลบข้อมูลสถานศึกษาเรียบร้อย", "success");
          await this.conditions_transferQueryAll();
        }
        this.deleteconditiondialog = false;
      }
    },

    // --- File Handling ---
    async AddConditionFile(id_ref) {
      let res = await this.$http.post("conditions_transfer.php", {
        ApiKey: this.ApiKey,
        id_ref
      });
      this.conditions_transfers_File = res.data;
      this.documentsLinkfile = null;
      this.Filecondition_transfer_dialog = true;
    },

    async FileconditionSubmit() {
      if (this.documentsLinkfile) {
        let formData = new FormData();
        let filename = this.conditions_transfers_File.id_ref + "condition.pdf";
        formData.append("ApiKey", this.ApiKey);
        formData.append("file", this.documentsLinkfile);
        formData.append("filename", "../HRvecfiles/" + filename);

        let uploadRes = await this.$http.post("uploadfile.php", formData, {
          headers: { "Content-Type": "multipart/form-data" }
        });
        if (uploadRes.data.status) {
          this.updateFileconditions = {
            ApiKey: this.ApiKey,
            id_ref: this.conditions_transfers_File.id_ref,
            documentsLinkfile: filename
          };
          await this.updateStatus(
            "conditions_transfer.update.php",
            this.updateFileconditions,
            "อัปโหลดเรียบร้อย"
          );
          this.Filecondition_transfer_dialog = false;
        } else {
          this.showSnackbar("อัปโหลดไม่สำเร็จ", "error");
        }
      }
    },

    viewdocumentsLinkfile(file) {
      this.pdf_files = file;
      this.pdfdocumentsLinkfileDialog = true;
    },

    row_classes(item) {
      return item.status_confirm === "cc" ? "yellow lighten-5" : "";
    },

    showSnackbar(text, color) {
      this.snackbar = {
        show: true,
        text,
        color,
        icon: color === "success" ? "mdi-check-circle" : "mdi-alert"
      };
    }
  }
};
</script>

<style scoped>
.custom-table >>> thead th {
  font-weight: 600 !important;
  color: #333 !important;
  background-color: #f5f5f5;
}
.shadow-sm {
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1) !important;
  transition: transform 0.2s, box-shadow 0.2s;
}
.shadow-sm:hover {
  transform: translateY(-2px);
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1) !important;
}
.cursor-pointer {
  cursor: pointer;
}
</style>
